import { render } from "./ManageAssignmentsPage.vue?vue&type=template&id=87bc1774&scoped=true&ts=true"
import script from "./ManageAssignmentsPage.vue?vue&type=script&lang=ts"
export * from "./ManageAssignmentsPage.vue?vue&type=script&lang=ts"

import "./ManageAssignmentsPage.vue?vue&type=style&index=0&id=87bc1774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bc1774"]])

export default __exports__